var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8319 8.01002L14.2819 2.77002C13.0019 1.75002 11.0019 1.74002 9.73192 2.76002L3.18192 8.01002C2.24192 8.76002 1.67192 10.26 1.87192 11.44L3.13192 18.98C3.42192 20.67 4.99192 22 6.70192 22H17.3019C18.9919 22 20.5919 20.64 20.8819 18.97L22.1419 11.43C22.3219 10.26 21.7519 8.76002 20.8319 8.01002ZM12.7519 18C12.7519 18.41 12.4119 18.75 12.0019 18.75C11.5919 18.75 11.2519 18.41 11.2519 18V15C11.2519 14.59 11.5919 14.25 12.0019 14.25C12.4119 14.25 12.7519 14.59 12.7519 15V18Z",
    fill: "#9BA7BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3dc58220dc865ec443e2835ec0a2054c.svg";
export { ForwardRef as ReactComponent };